module.exports = __webpack_public_path__ + "img/youtube-logo.cf0a9f81.svg";